import type { ActivationAlertsContractNewsMetric } from "@similarweb/pro-api-client";

import type { ValueMap } from "../../common/widget/table/computeLeaders";
import { addToValueMap, getLeadersFromMap } from "../../common/widget/table/computeLeaders";

export const computeLeaders = (data: ActivationAlertsContractNewsMetric[]) => {
    const mentionsMap: ValueMap = new Map();
    const pressReleasesMap: ValueMap = new Map();
    const storiesMap: ValueMap = new Map();

    data.forEach((item) => {
        addToValueMap({ map: mentionsMap, value: item.mentions.volume, domain: item.domain });
        addToValueMap({ map: pressReleasesMap, value: item.pressReleases.volume, domain: item.domain });
        addToValueMap({ map: storiesMap, value: item.stories.volume, domain: item.domain });
    });

    return {
        mentions: getLeadersFromMap(mentionsMap),
        pressReleases: getLeadersFromMap(pressReleasesMap),
        stories: getLeadersFromMap(storiesMap),
    };
};
